<template>
  <div class="d-flex">
    <b-form-input type="text"
        :placeholder="placeholder"
        v-model="localValue"
        :maxlength="maxlength"
        :required="required"
        :state="state"
        v-mask="['##/##/####']">
    </b-form-input>
    <b-form-datepicker
        ref="formDatePicker"
        button-only
        button-variant="addon-square"
        right
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        locale="pt-BR"
        aria-controls="dataEnvio"
        label-no-date-selected=""
        @context="onContext"
    >
      <template #button-content>
          <i class="fas fa-calendar-alt"></i>
      </template>
    </b-form-datepicker>
  </div>
</template>

<script>
export default {
  name: 'NxDatePicker',
  props: {
    value: {
      type: String | Date,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: 'DD/MM/YYYY'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    state: {
      type: Boolean | null,
      required: false,
      default: null
    },
    maxlength: {
      type: Number,
      required: false,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'update:value'
  },
  data () {
    return {
      localValue: null,
      selectedValue: null
    }
  },
  watch: {
    localValue (newValue) {
      if (newValue !== this.value) {
        this.$emit('update:value', newValue)
      }
    },
    value (newValue) {
      this.localValue = newValue
    }
  },
  methods: {
    onContext (ctx) {
      let value = ctx.selectedFormatted

      if (value && this.localValue !== value) {
        this.localValue = value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/NxDatePicker.vue